var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{class:['m-is-' + _vm.type, 'btn-size-' + _vm.size],attrs:{"loading":_vm.loading}},[(_vm.icon)?_c('i',{class:[_vm.icon, 'pr-2']}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }